import * as moment from 'moment';
import 'moment/locale/bg';

export const init = (lang) => {
  moment.locale(lang);
};

export const getHumanizedRemainingTimeTo = (timestamp) => {
  return moment(timestamp).from();
};

export const getHumanizedDate = (timestamp) => {
  return moment(timestamp).format('dddd, Do MMMM YYYY, HH:mm');
};

export const getHumanizedShortDate = (timestamp) => {
  return moment(timestamp).format('Do MMMM YYYY');
};

export const getDaysToDate = (timestamp) => {
  const day = moment(timestamp);
  const now = moment();

  // Add one day, so it is always rounded UP.
  return day.diff(now, 'days') + 1;
};

export const isOlderThanDays = (date, days) => {
  return moment().diff(date, 'days') > days;
};

export const getFirstDayOfTheYearsToCome = (yearsToAdd = 1) =>
  moment
    .utc()
    .add(yearsToAdd, 'years')
    .startOf('year')
    .valueOf();

export const getHumanizedYear = (time) => moment.utc(time).format('YYYY');

export const getTimestampFromDbDay = (time) => moment.utc(time).valueOf();



// WEBPACK FOOTER //
// ./src/utils/date.js